import { PublicSharedApiService } from './public-shared-api.service';
import { endpoint } from './shared-api.service';
import { GetWorkerExistsByEmailParams } from './worker-service.types';

const publicSharedApi = new PublicSharedApiService(endpoint);

export const getWorkerExistsByEmail = async ({
  email,
  verified,
  level,
}: GetWorkerExistsByEmailParams): Promise<boolean> => {
  return publicSharedApi.get<boolean>({
    path: 'public/worker/exists-by-email',
    params: { email, verified, level },
  });
};
